import React, { Component } from 'react';
import { Col, Popconfirm } from 'antd';

import { StyledRow, ParcelName, ParcelDescription } from 'components/Styled';
import ParcelNumberInput from './ParcelNumberInput';

class BoxInputRow extends Component {
  render() {
    const { boxType, boxSize, boxQuantity } = this.props;
    const { length, width, height } = boxSize;
    return (
      <StyledRow type="flex" align="middle">
        <Col span={6} style={{ textAlign: 'center' }}>
          <img
            src={this.props.boxImage}
            style={this.props.boxImageStyle}
            alt={this.props.t(`quotation.parcel_form.boxes.${boxType}`)}
          />
        </Col>
        <Col span={6}>
          <ParcelName>
            {this.props.t(`quotation.parcel_form.boxes.${boxType}`)}
          </ParcelName>
          <br />
          <ParcelDescription>
            {this.props.t('quotation.parcel_form.box_size', {
              length,
              width,
              height
            })}
          </ParcelDescription>
          <br />
          <span
            className="buttonTheme-color"
            style={{
              color: '#57D7DD',
              fontWeight: 700,
              textDecoration: 'underline',
              fontSize: '12px'
            }}>
            <Popconfirm
              icon={null}
              title={
                <span style={{ fontSize: '12px' }}>
                  {this.props.t('common.confirm_delete', {
                    content: `(${length} x ${width} x ${height} cm)`
                  })}
                </span>
              }
              onConfirm={this.props.handleRemoveBox}
              okText={this.props.t('button.remove')}
              cancelText={this.props.t('button.cancel')}
              cancelButtonProps={{
                ghost: true,
                className: 'theme-button',
                type: 'primary',
                style: {
                  fontSize: '12px'
                }
              }}
              okButtonProps={{
                className: 'theme-button',
                type: 'primary',
                style: {
                  fontSize: '12px'
                }
              }}>
              <span style={{ cursor: 'pointer' }}>
                {this.props.t('button.remove')}
              </span>
            </Popconfirm>
            {boxType !== 'envelope' && (
              <span
                style={{ cursor: 'pointer', marginLeft: '23px' }}
                onClick={() => {
                  this.props.handleDrawerOpen({ boxType, boxSize });
                }}>
                {this.props.t('button.edit')}
              </span>
            )}
          </span>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <ParcelNumberInput
            value={boxQuantity}
            onChange={value => {
              this.props.handleBoxChange(value);
            }}
          />
        </Col>
      </StyledRow>
    );
  }
}

export default BoxInputRow;
